import { render, staticRenderFns } from "./FilterTokenPriced.vue?vue&type=template&id=083b4576&scoped=true"
import script from "./FilterTokenPriced.vue?vue&type=script&lang=ts"
export * from "./FilterTokenPriced.vue?vue&type=script&lang=ts"
import style0 from "./FilterTokenPriced.vue?vue&type=style&index=0&id=083b4576&prod&lang=scss&scoped=true"
import style1 from "./FilterTokenPriced.vue?vue&type=style&index=1&id=083b4576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b4576",
  null
  
)

export default component.exports